import { useMemo } from 'react';
import { stableCoins } from '@/components/explore/stableCoins';
export default function useParseAssetsIntoNativeAndCash(assetData, networkId) {
    var _networkStableCoins = function (_networkId) {
        return stableCoins
            .filter(function (_coin) { var _a; return (_a = _coin.networks) === null || _a === void 0 ? void 0 : _a.includes(_networkId); })
            .map(function (_coin) { return ({
            name: _coin.name,
            address: _coin.tokens[_networkId],
            network: _networkId,
        }); });
    };
    var _nativeNetworkBalances = useMemo(function () {
        if (!assetData || !networkId)
            return [];
        return assetData.balancesByChain
            .find(function (_chain) { return _chain.chainId === networkId; })
            .balances.filter(function (_token) {
            return _token.native_token ||
                _networkStableCoins(networkId).some(function (_coin) { return _coin.address.toLowerCase() === _token.contract_address.toLowerCase(); });
        })
            .sort(function (a, b) {
            if (a.native_token && !b.native_token)
                return -1;
            if (!a.native_token && b.native_token)
                return 1;
            return 0;
        });
    }, [assetData, networkId]);
    var _otherNetworkNativeBalances = useMemo(function () {
        if (!assetData || !networkId)
            return [];
        return assetData.balances
            .filter(function (_token) { return _token.native_token; })
            .filter(function (a) { return a.usd_value > 0 && a.network !== networkId; })
            .sort(function (a, b) {
            if (a.network == 1) {
                return 100;
            }
            if (b.network == 1) {
                return -100;
            }
            return b.usd_value - a.usd_value;
        });
    }, [assetData, networkId]);
    var _allCashBalances = useMemo(function () {
        if (!assetData || !networkId)
            return [];
        return assetData.balances.filter(function (_token) {
            return _networkStableCoins(_token.network).some(function (_coin) { return _coin.address.toLowerCase() === _token.contract_address.toLowerCase(); });
        });
    }, [assetData, networkId]);
    return {
        _networkStableCoins: _networkStableCoins,
        _allCashBalances: _allCashBalances,
        _nativeNetworkBalances: _nativeNetworkBalances,
        _otherNetworkNativeBalances: _otherNetworkNativeBalances,
    };
}
